import React, { useState, useEffect } from 'react';
import { Radio, Divider } from '@material-ui/core';
import DialogBox from '../DialogBox';
import ProductAddToCart from '../ProductAddToCart';
import css from './index.module.scss';
import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import DrawerPwa from '../DrawerPwa';
import BackButton from '../BackButton';
import ribbonImg from './images/ribbon.svg';

import {
  getVariantDetails,
  getAddedItems as dealAddedItems,
  getAdditionalPrice,
  getRemovedItems as dealRemovedItems,
  isProductCustomized,
  decimalChecker,
} from 'spwa-ui-library/esm/utils/helper';
import noImg from '../../assets/no-itm.png';
import BundleStepThumb from './BundleStepThumb';
import { getSelectedItem as dealSelectedItem, getSelectedItem } from '../../utils/helper';

import { useLocation, useNavigate } from '@reach/router';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import { Dot } from '../Icons';
import CustomizationSkelton from './CustomizationSkelton';
const { useSelector } = Redux;

const { setStatus, setDetailsFetched, getProductInfo, selectProductEntities } = Slices.productSlice;
const { updateWithIndex, sendLocalCart, addWithoutCalculation } = Slices.cartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { selectCountryValidations, getClusterId } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectDesktop } = Slices.appSlice;
const {
  addProductToCustomize,
  selectCustomizeProductById,
  removeFromCustomization,
  removeFromCart,
  updateProductPayload,
} = Slices.tempCartSlice;

function ProductCustomizationDialog({
  productId,
  currentStepperId,
  setCurrentStepperId,
  showCustomizeProductDialog,
  setShowCustomizeProductDialog,
  setShowBundleGroupDialog,
  oldLocation,
  returnURL,
}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const temp = useSelector((state) => state.tempCart);
  const cart = useSelector((state) => state.cart);
  const categoryList = useSelector((state) => state.category);
  const productsMap = useSelector(selectProductEntities);
  const isDesktop = useSelector(selectDesktop);
  const clusterId = useSelector(getClusterId);
  const defaultAddress = useSelector(selectDefaultAddress);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const tagsState = useSelector((state) => state.tags);
  const [selectedOption, setSelectedOption] = useState(0);
  const [showLoader, setShowLoader] = useState(0);
  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = productId > 0 || locationSearch.has('main_product') || false;
  const mainProductId = productId || locationSearch.get('main_product');

  let productObj = productsMap[productId || showCustomizeProductDialog];

  const fetchProduct = async () => {
    let checkVal;
    if (
      productObj.bundleTypeId === 'bundle_group' &&
      customizeItem.additionalInfo?.selectedBundleId
    ) {
      checkVal = await dispatch(
        getProductInfo({
          id: customizeItem.additionalInfo?.selectedBundleId,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: productObj?.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      );
    } else {
      checkVal = await dispatch(
        getProductInfo({
          id: productObj?.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: productObj?.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      );
    }

    if (checkVal) {
      setShowLoader(false);
    }
  };
  React.useEffect(() => {
    // debugger;
    if (productObj?.typeId === 'bundle' || productObj?.typeId === 'bundle_group') {
      // debugger;
      setShowLoader(true);
      fetchProduct();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let customizationIndex = temp.data.items.findIndex(
    (item) => item.id == (productId || showCustomizeProductDialog)
  );
  let customizations = temp.data.items[customizationIndex];
  const selectCustomize = useSelector((state) =>
    selectCustomizeProductById(state, productId || showCustomizeProductDialog)
  );

  let categoryId = productObj?.categories?.[0];
  let buildCat = false;
  if (countryValidations.makeYourOwnPizza?.categoryId >= 1) {
    buildCat = countryValidations.makeYourOwnPizza?.categoryId == categoryId ? true : false;
  }
  let productSteps;

  if ((productObj?.typeId == 'bundle_group' || productObj?.typeId == 'bundle') && productId) {
    // updating customizations
    let customizationBundle = customizations?.items
      ? customizations?.items
      : customizations?.bundle;

    // fetch latest customization obj with step lesser than currentStepperId
    for (let [stepId, stepObj] of Object.entries(customizationBundle || {})) {
      // if (stepId >= currentStepperId) break;
      for (let [prodObjId, prodObj] of Object.entries(stepObj || {})) {
        if (prodObjId == showCustomizeProductDialog && !prodObj?.isDefault) {
          customizations = prodObj;
        }
      }
    }

    // updating productObj
    let stepInfo;
    if (productsMap[productId]?.isBOGO || productsMap[productId]?.bundleTypeId == 'bundle_group') {
      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[productId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      productSteps = bgSteps?.steps;
      stepInfo = bgSteps?.steps?.find((step) => step?.id == currentStepperId);
    } else {
      productSteps = productsMap[mainProductId]?.steps;
      stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepperId);
    }

    productObj = stepInfo?.options?.find((option) => option?.id == showCustomizeProductDialog);
  }

  const sellingPrice =
    customizations?.price || productObj?.specialPrice || productObj?.originalPrice;
  // eslint-disable-next-line no-unused-vars
  let bundleItemIndex = 0; // for bundle item
  let selectedDealItem = dealSelectedItem(customizations, productObj);

  let addedDealItems = dealAddedItems(customizations, selectedDealItem); // for configurable product
  let removedDealItems = dealRemovedItems(customizations, selectedDealItem); // for configurable product

  let productTags =
    tagsState.status === 'succeeded'
      ? Object.values(tagsState?.data || {})
          .filter((tag) => productObj?.tags?.includes(tag.tagId))
          .sort((tag1, tag2) => tag1.position - tag2.position)
      : [];

  productTags = productTags.map((productTag) =>
    countryValidations?.['tags_assets']?.find((tagAsset) => tagAsset.tagId == productTag.tagId)
  );

  let variantKeys = Object.values(customizations?.variants || {});
  let selectedItem = productsMap[showCustomizeProductDialog]?.items?.find((item) => {
    let itemInfo;
    if (!item?.id) {
      itemInfo = productsMap[item];
    } else {
      itemInfo = item;
    }

    let isSameVariant = true;
    let selectedObj = {};
    for (let i = 0; i < variantKeys.length; i++) {
      if (itemInfo[`sel${i + 1}Value`] != variantKeys[i]) {
        isSameVariant = false;
        break;
      }
    }
    return selectedObj;
  });

  if (!selectedItem?.id) {
    selectedItem = productsMap[selectedItem];
  }

  useEffect(() => {
    if (!isBundleItem && selectedItem && !selectedItem?.steps?.[0]?.options) {
      let initialData = productsMap[showCustomizeProductDialog];
      dispatch(
        getProductInfo({
          id: initialData?.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: initialData?.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem?.id]);

  const handleCheckout = () => {
    if (productId) {
      console.log(`hereee.....`);
      let productCustomizationPayload = JSON.parse(
        JSON.stringify(temp.data.items[customizationIndex] || {})
      );

      let cartPayload = cart.data?.items?.find((item) => item.id == productId);

      if (!cartPayload) {
        if (locationSearch.has('cartId')) {
          cartPayload = cart.data?.items[locationSearch.get('cartId')];
          cartProduct = cart.data?.items[locationSearch.get('cartId')];
        } else {
          cartPayload = cart.data?.items?.find(
            (item) =>
              item.catId == productId ||
              item?.additionalInfo?.selectedBundleId == productId ||
              item?.additionalInfo?.bundleGroupId == productId
          );
          cartProduct = cart.data?.items?.find(
            (item) =>
              item.catId == productId ||
              item?.additionalInfo?.selectedBundleId == productId ||
              item?.additionalInfo?.bundleGroupId == productId
          );
        }
      }

      let productCustomizationPayloadBundle = productCustomizationPayload?.items
        ? productCustomizationPayload['items']
        : productCustomizationPayload['bundle'];

      if (!productCustomizationPayloadBundle?.[currentStepperId]) {
        productCustomizationPayloadBundle[currentStepperId] = {};
      }

      let productVariations = Object.values(customizations?.variants || {});
      let selectedItemObj = productObj;

      if (productVariations?.length) {
        selectedItemObj = productObj?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          let isVariantSame = true;
          productVariations.forEach((variant, index) => {
            if (itemInfo[`sel${index + 1}Value`] != variant) {
              isVariantSame = false;
            }
          });
          return isVariantSame;
        });

        if (!selectedItemObj?.id) {
          selectedItemObj = productsMap[selectedItemObj];
        }

        if (!selectedItemObj?.steps?.[0]?.options) {
          selectedItemObj = productsMap[productObj?.id]?.items?.find(
            (item) => item?.id == selectedItemObj?.id
          );
        }
      }

      let newProductCustomization;
      if (selectedOption == 0) {
        // add previous customizations
        newProductCustomization = customizations;

        // add customization price
        let addedCustomizationPrice = 0;
        let itemExtraPrice = 0;
        let itemBasePrice =
          selectedItemObj?.price >= 0
            ? selectedItemObj?.price
            : selectedItemObj?.originalPrice || selectedItemObj?.specialPrice || 0;

        for (let step of selectedItemObj?.steps || []) {
          for (let option of step?.options || []) {
            if (option?.subOptions) {
              itemExtraPrice +=
                option?.subOptions[customizations?.items?.[step.id]?.[option.id]?.['qty'] - 1]
                  ?.price || 0;
            } else {
              if (customizations?.items?.[step.id]?.[option.id]?.['qty']) {
                itemExtraPrice +=
                  (option?.price || 0) *
                  Number(customizations?.items?.[step.id]?.[option.id]?.['qty'] || 0);
              }
            }
          }
        }

        if (!productsMap[productId || productObj?.id]?.isBOGO) {
          addedCustomizationPrice = parseFloat(itemBasePrice);
        }
        addedCustomizationPrice += parseFloat(itemExtraPrice);

        productCustomizationPayload.price =
          productCustomizationPayload.price + addedCustomizationPrice * (cartPayload?.qty || 1);
      } else {
        // calculate default variation
        let variations = {};
        Object.values(productObj?.variants || {}).forEach((variant, index) => {
          const selection = variant?.options?.find((option) => option?.isSelected == 1);
          if (selection) {
            variations[variant?.id] = selection?.id;
          }
        });

        selectedItemObj = productObj?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          let isVariantSame = true;
          Object.values(variations || {}).forEach((variant, index) => {
            if (itemInfo[`sel${index + 1}Value`] != variant) {
              isVariantSame = false;
            }
          });
          return isVariantSame;
        });

        if (!selectedItemObj?.id) {
          selectedItemObj = productsMap[selectedItemObj];
        }

        if (!selectedItemObj?.steps?.[0]?.options) {
          selectedItemObj = productsMap[productObj?.id]?.items?.find(
            (item) => item?.id == selectedItemObj?.id
          );
        }

        let itemBasePrice =
          selectedItemObj?.price >= 0
            ? selectedItemObj?.price
            : selectedItemObj?.originalPrice || selectedItemObj.specialPrice || 0;

        newProductCustomization = {
          qty: 1,
          variants: variations,
          isDefault: true,
        };

        if (!productsMap[productId || productObj?.id]?.isBOGO) {
          productCustomizationPayload.price = productCustomizationPayload.price + itemBasePrice;
        }
      }

      productCustomizationPayloadBundle[currentStepperId][productObj?.id] = newProductCustomization;

      if (productCustomizationPayload?.items) {
        productCustomizationPayload['items'] = productCustomizationPayloadBundle;
      } else {
        productCustomizationPayload['bundle'] = productCustomizationPayloadBundle;
      }

      const availableProductSteps = productSteps?.filter((s) => !s?.isHidden);
      let stepIndex = availableProductSteps?.findIndex((step) => step.id == currentStepperId);
      let nextStep = availableProductSteps?.[stepIndex + 1] || availableProductSteps?.[stepIndex];

      if (productCustomizationPayload?.additionalInfo?.addedProducts) {
        productCustomizationPayload['additionalInfo']['addedProducts'] =
          (productCustomizationPayload['additionalInfo']['addedProducts'] || 0) + 1;
      }

      console.log(`productCustomizationPayload -- `, productCustomizationPayload);

      dispatch(updateProductPayload({ data: productCustomizationPayload }));
      setShowCustomizeProductDialog((prev) => 0);

      if (setCurrentStepperId && nextStep) {
        console.log(`5 setting unlockedStepperId to - `, nextStep?.id);
        window.localStorage.setItem('unlockedStepperId', nextStep?.id);
        setCurrentStepperId((prev) => parseInt(nextStep?.id));
      }

      return;
    }

    // normal flow --
    if (selectedOption == 0) {
      // previous customizations
      let payload = temp?.customize?.items?.find((item) => item.id == showCustomizeProductDialog);

      if (!payload) {
        payload = temp?.customize?.items?.find((item) => item.catId == showCustomizeProductDialog);
      }

      // update payload for bogo
      let bundleId;
      if (productsMap[productId || productObj?.id]?.isBOGO && payload?.bundle) {
        const subItems = [];
        let productCategory = parseInt(Object.keys(payload?.bundle || {})[0]);
        const categoryId = (productCategory - (productCategory % 10)) / 10;
        bundleId = categoryId;
        const productItems = Object.values(payload?.bundle || {});
        const stepIds = Object.keys(payload?.bundle || {});
        let idx = 0;

        for (let items of productItems) {
          let item = JSON.parse(JSON.stringify(items));
          for (let [itemsId, itemsInfo] of Object.entries(item)) {
            if (itemsInfo?.notAdded) {
              delete item[itemsId];
            }
          }

          const stepId = stepIds[idx];
          const itemId = Object.keys(item || {})[0];
          const itemInfo = Object.values(item || {})[0];

          subItems.push({
            ...itemInfo,
            id: itemId,
            typeId: 'configurable',
            catId: categoryId,
            isDefault: itemInfo?.items ? false : true,
            stepId: stepId,
          });
          idx += 1;
        }

        subItems.sort((item1, item2) => item2.price - item1.price);
        subItems[subItems.length - 1].price = 0;

        payload = JSON.parse(JSON.stringify(payload || {}));

        let selectedBundleId = bundleId || productObj['id'];
        let bundle = payload['bundle'];
        delete payload['bundle'];
        payload['subItem'] = subItems;
        payload['catId'] = payload['id'];
        delete payload['id'];
        delete payload['typeId'];
        if (!payload?.additionalInfo) {
          payload['additionalInfo'] = {};
        }
        payload['additionalInfo']['selectedBundleId'] = selectedBundleId;
        payload['additionalInfo']['catId'] = productObj?.categories?.[0] || categoryId;
        payload['additionalInfo']['bundle'] = bundle;
      }

      if (
        productsMap[productId || productObj?.id]?.typeId == 'simple' &&
        productsMap[productId || productObj?.id]?.bundleTypeId?.includes('bundle')
      ) {
        payload = JSON.parse(JSON.stringify(payload || {}));
        payload['typeId'] = 'simple';
        payload['items'] = payload['bundle'];
        delete payload['bundle'];
      }

      if (payload?.qty > 0) {
        payload = JSON.parse(JSON.stringify(payload || {}));
        let perUnitPrice = (payload?.price || 0) / (payload?.qty || 1);

        payload['qty'] = 1;
        payload['price'] = perUnitPrice;
      }

      if (productsMap[productId || productObj?.id]?.typeId == 'bundle_group') {
        payload = JSON.parse(JSON.stringify(payload || {}));
        payload[`parentId`] = productId || productObj?.id;
      }

      payload = JSON.parse(JSON.stringify(payload));
      // delete notAdded:true ones
      if (payload['items'] || payload['bundle']) {
        let payloadBundle = JSON.parse(JSON.stringify(payload?.items || payload?.bundle || {}));
        for (let [payloadStep, payloadStepInfo] of Object.entries(payloadBundle || {})) {
          for (let [payloadStepProduct, payloadStepProductInfo] of Object.entries(
            payloadStepInfo || {}
          )) {
            if (payloadStepProductInfo?.notAdded) {
              delete payloadBundle[payloadStep][payloadStepProduct];
            }
          }
        }
        if (payload['items']) {
          payload['items'] = payloadBundle;
        } else {
          payload['bundle'] = payloadBundle;
        }
      }

      dispatch(
        addWithoutCalculation({
          ...payload,
          usePayloadPrice: true,
          // // parentId: productID,
          // product: productObj,
          id: payload?.additionalInfo?.selectedBundleId || payload.id,
        })
      );
    } else {
      // default Customization

      dispatch(
        removeFromCustomization({
          id: showCustomizeProductDialog,
        })
      );

      //! TODO: Check impact on uncommenting below code
      dispatch(
        removeFromCart({
          id: showCustomizeProductDialog,
        })
      );

      dispatch(
        sendLocalCart({
          productType: productsMap[showCustomizeProductDialog].bundleTypeId,
          updatedOn: new Date().getTime(),
          mainProductId: productsMap[showCustomizeProductDialog].id,
          data: {
            ...productsMap[showCustomizeProductDialog],
            items: productsMap[showCustomizeProductDialog].items,
            category: productsMap[showCustomizeProductDialog]['categories'][0],
          },
        })
      );
    }
    setShowCustomizeProductDialog((prev) => 0);
  };

  const getAddedItems = () => {
    let addedString = [];

    if (customizations?.items) {
      for (let [key, item] of Object.entries(customizations?.['items'])) {
        let optionKeys = Object.keys(item);
        let currentStep = selectedItem?.steps?.find((step) => step.id == key);

        let selectedOptions = currentStep?.options?.filter((option) =>
          optionKeys?.includes(option.id.toString())
        );

        if (selectedOptions) {
          for (let selectedOption of selectedOptions) {
            addedString.push(
              selectedOption['title'] + (item[selectedOption.id]['qty'] > 1 ? ' (Extra)' : '')
            );
          }
        }
      }
    }

    return addedString.join(', ');
  };

  const getDefaultItems = () => {
    let addedString = [];
    if (selectedItem?.steps) {
      for (let step of selectedItem?.steps) {
        let defaultOptions = step?.options?.filter((option) => {
          if (option?.subOptions) {
            return option?.subOptions?.filter((subOption) => subOption?.default == 1).length > 0;
          } else {
            return option?.default == 1;
          }
        });
        for (let defaultOption of defaultOptions || []) {
          addedString.push(defaultOption['title']);
        }
      }
    }

    return addedString.join(', ');
  };

  const getRemovedItems = () => {
    let removedString = [];

    if (selectedItem?.steps) {
      for (let step of selectedItem?.steps) {
        let defaultOptions = step?.options?.filter((option) => option?.default == 1);
        let stepOptions = customizations?.['items']?.[step.id]
          ? Object.keys(customizations?.['items']?.[step.id])
          : [];
        for (let defaultOption of defaultOptions || []) {
          if (!stepOptions.includes(defaultOption?.id)) {
            removedString.push(defaultOption['title']);
          }
        }
      }
    }

    return removedString.join(', ');
  };

  const getProductPrice = () => {
    let finalPrice = 0;

    // add base price -
    finalPrice += selectedItem?.specialPrice || selectedItem?.originalPrice || 0;

    // add price for additional items such as sauce and toppings
    if (selectedItem?.steps) {
      for (let step of selectedItem?.steps || []) {
        for (let option of step?.options || []) {
          if (option?.subOptions) {
            finalPrice +=
              option?.subOptions[customizations?.items?.[step.id]?.[option.id]?.['qty'] - 1]
                ?.price || 0;
          } else {
            if (customizations?.items?.[step.id]?.[option.id]?.['qty']) {
              finalPrice +=
                (option?.price || 0) *
                Number(customizations?.items?.[step.id]?.[option.id]?.['qty'] || 0);
            }
          }
        }
      }
    }

    return finalPrice;
  };

  // GET SELECTED OPTION
  const getSelectedOptions = () => {
    const selectedOptions = [];

    if (customizations?.items || customizations?.bundle) {
      let dealBundle = customizations?.items ? customizations?.items : customizations?.bundle;
      let p = null;
      for (let [stepId, stepInfo] of Object.entries(dealBundle || {})) {
        for (let [prodId, prodInfo] of Object.entries(stepInfo || {})) {
          if (prodId == showCustomizeProductDialog) {
            p = prodInfo;
          }
        }
      }
      customizations = p || customizations;
    }

    let selectedVariants = Object.values(customizations?.variants || {});

    let product = productsMap[showCustomizeProductDialog];
    if (isBundleItem) {
      let stepInfo;
      if (
        productsMap[mainProductId]?.isBOGO ||
        productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
      ) {
        const paramsStepId = parseInt(locationSearch.get('step'));
        const optionId = parseInt(locationSearch.get('option'));

        let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
      } else {
        stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepperId);
      }
      product = stepInfo?.options?.find((option) => option?.id == showCustomizeProductDialog);
    }

    if (!product) {
      product = productObj;
    }

    if (selectedVariants?.length) {
      if (product?.variants) {
        product.variants.forEach((variant, index) => {
          variant.options.forEach((option) => {
            if (option.id == selectedVariants[index]) {
              selectedOptions.push(option.title);
            }
          });
        });
      }
    } else {
      if (product?.variants) {
        product.variants.forEach((variant) => {
          variant.options.forEach((option) => {
            if (option.isSelected === 1) {
              selectedOptions.push(option.title);
            }
          });
        });
      }
    }

    return selectedOptions;
  };

  let addedItems = getAddedItems();
  let removedItems = getRemovedItems();
  let price = getProductPrice();
  let defaultItems = getDefaultItems();
  const [selectedSize, selectedType] = getSelectedOptions();

  const specialPrice = parseFloat(selectedItem?.specialPrice);
  const originalPrice = parseFloat(selectedItem?.originalPrice);
  const totalPrice = parseFloat(price) - (specialPrice ?? originalPrice) || 0;

  const repeatTitle = () => (
    <div className={css.productCustomizationRow}>
      <Radio
        checked={selectedOption == 0}
        color="primary"
        id={showCustomizeProductDialog}
        edge="end"
        onClick={() => setSelectedOption(0)}
      />
      <span className={cx(css.customizeDialogTitle, css.textColor)}>
        <FormattedMessage
          id="repeat_last_saved_customisation"
          defaultMessage="Repeat last saved customisation"
        />
      </span>
    </div>
  );

  let isCustomized =
    temp.customize.items.filter((product) => product?.id == productObj?.id)?.length > 0;
  if (isBundleItem) {
    const productCustomization = temp.data.items.find((product) => product.id == mainProductId);

    let allProducts = [];
    for (let step of Object.values(productCustomization?.['bundle'] || {})) {
      for (let [pId, pObj] of Object.entries(step)) {
        allProducts = [...allProducts, { ...pObj, id: pId }];
      }
    }
    let matches = allProducts?.filter((item) => item?.id == productObj?.id);
    let actualMatches = [];
    for (let match of matches) {
      let doesVariationExist = true;
      for (let [variantId, selectedVariant] of Object.entries(match?.variants || {})) {
        // check if this combo exists in productObj or not
        let currentVariation = productObj?.variants?.find((v) => v.id == variantId);
        let currentSelectedVariation = currentVariation?.options?.find(
          (cv) => cv.id == selectedVariant
        );

        if (!currentSelectedVariation) {
          doesVariationExist = false;
        }
      }

      if (doesVariationExist) {
        actualMatches.push(match);
      }
    }
    matches = actualMatches;

    isCustomized = matches.length > 0 && isProductCustomized(productObj, matches[0]);
  }

  let isProductInCart =
    cart.data.items.filter((product) => product?.id == productObj?.id)?.length > 0;

  const handleRoute = (e) => {
    e.preventDefault();

    if (isBundleItem) {
      const productCustomizationData = temp.data.items.find(
        (product) => product.id == mainProductId
      );
      window.localStorage.setItem('customizationData', JSON.stringify(productCustomizationData));
    }

    if (productId) {
      const category = categoryList.entities[productsMap[productId]?.['categories']?.[0]];

      let productRoute = generateProductRoute({
        product: productObj,
        category,
        locale: intl.locale.toLowerCase(),
      });

      let state = {
        state: {
          retUrl: returnURL,
        },
      };
      try {
        if (oldLocation) {
          state['state']['oldLocation'] = oldLocation;
          state['state']['oldLocation']['retUrl'] = oldLocation.pathname;
          state['state']['oldLocation']['state']['retUrl'] = oldLocation.pathname;
          state['state']['description'] = productObj?.title || productObj?.name;
        }
      } catch (error) {
        console.log(error);
      }
      productRoute += `?main_product=${productId}&step=${currentStepperId}`;

      if (productsMap[productId]?.typeId == 'bundle_group') {
        productRoute += `&option=${locationSearch.get(`option`)}`;
      }

      // update default product in tempCart
      const productCustomization = temp.data.items.find((product) => product.id == productId);
      const newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

      // generate correct object for step ID
      let variants = {},
        itemPayload = { qty: 1 },
        variationArray = [-1, -1, -1];

      // eslint-disable-next-line no-unused-expressions
      productObj?.variants?.forEach((variant, index) => {
        const selectedOption = variant?.options.find((option) => option.isSelected == 1);
        if (selectedOption) {
          variants[variant.id] = selectedOption.id;
          variationArray[index] = selectedOption.id;
        }
      });

      itemPayload['variants'] = variants;

      // contains items such as toppings, add them
      let selectedItemIndex = -1;

      if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
        selectedItemIndex = 0;
      } else {
        // eslint-disable-next-line no-unused-expressions
        productObj?.items?.forEach((item, i) => {
          let areVariationsSame = true;
          variationArray.forEach((value, index) => {
            if (item[`sel${index + 1}Value`] != value) {
              areVariationsSame = false;
            }
          });

          if (areVariationsSame) {
            selectedItemIndex = i;
          }
        });
      }

      if (selectedItemIndex > -1) {
        let currentProductVariation = productObj?.items[selectedItemIndex];
        if (!currentProductVariation?.steps?.[0]?.options) {
          currentProductVariation = productsMap[productObj?.id]?.items?.find(
            (item) => item?.id == currentProductVariation?.id
          );
        }

        let items = {};
        let steps = currentProductVariation?.steps;
        if (!steps?.[0]?.options) {
          steps = productObj?.items?.find(
            (item) => item?.id == productObj?.items[selectedItemIndex]?.id
          )?.steps;
        }
        // eslint-disable-next-line no-unused-expressions
        steps?.forEach((step) => {
          items[step.id] = {};
          // eslint-disable-next-line no-unused-expressions
          step?.options?.forEach((option) => {
            if (option?.subOptions) {
              const selectedSubOptions = option?.subOptions?.filter(
                (subOption) => subOption.selected == 1
              );
              if (selectedSubOptions?.length > 0) {
                items[step.id][option.id] = {
                  qty: selectedSubOptions?.length,
                };
              }
            } else {
              if (option?.selected == 1) {
                items[step.id][option.id] = {
                  qty: 1,
                };
              }
            }
          });
          if (!Object.keys(items[step.id]).length) delete items[step.id];
        });

        let finalItems = {};
        for (let [keys, vals] of Object.entries(items)) {
          if (vals) {
            finalItems[keys] = vals;
          }
        }

        if (Object.keys(finalItems)?.length) itemPayload['items'] = finalItems;
      }

      if (!newProductCustomization?.['bundle']) {
        newProductCustomization['bundle'] = {};
      }
      if (!newProductCustomization?.['bundle']?.[currentStepperId]) {
        newProductCustomization['bundle'][currentStepperId] = {};
      }
      newProductCustomization['bundle'][currentStepperId][productObj.id] = itemPayload;
      newProductCustomization['bundle'][currentStepperId][productObj.id]['notAdded'] = true;
      dispatch(
        updateProductPayload({
          data: newProductCustomization,
        })
      );

      navigate(productRoute, state);
      setShowCustomizeProductDialog((prev) => 0);
      return;
    }

    if (!isCustomized || productObj?.typeId == 'bundle_group') {
      console.log(`removing unlockedStepperId 3`);
      window.localStorage.removeItem('unlockedStepperId');
    }
    if (
      (productObj?.bundleTypeId == 'bundle_group' || productObj?.typeId == 'bundle_group') &&
      setShowBundleGroupDialog
    ) {
      setShowBundleGroupDialog(mainProductId || productObj.id);
    } else {
      dispatch(setStatus('loading'));

      if (productsMap[mainProductId]?.isBOGO && locationSearch.has('option')) {
        categoryId = locationSearch.get('option');
      }

      dispatch(
        getProductInfo({
          id: mainProductId || productObj?.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: categoryId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        dispatch(setDetailsFetched(true));

        const customizedProducts = temp?.customize?.items.filter(
          (item) => item.id == (isBundleItem ? mainProductId : productObj.id)
        );

        // if (
        //   (!isCustomized && productObj?.typeId?.includes('bundle')) ||
        //   (customizedProducts.length == 0 && !locationSearch.has('cartId') && !isProductInCart)
        // ) {
        dispatch(
          addProductToCustomize({
            productType: productObj.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productObj.id,
            data: isBundleItem
              ? {
                  ...productsMap[mainProductId],
                  category:
                    categoryId == 999 ? productsMap[mainProductId]?.categories?.[0] : categoryId,
                  noIncrement: true,
                }
              : {
                  ...resp.payload,
                  category: categoryId == 999 ? resp?.payload?.categories?.[0] : categoryId,
                  noIncrement: true,
                },
          })
        );
        // }

        let state = {
          state: {
            retUrl: returnURL,
          },
        };
        try {
          if (oldLocation) {
            state['state']['oldLocation'] = oldLocation;
            state['state']['oldLocation']['retUrl'] = oldLocation.pathname;
            state['state']['oldLocation']['state']['retUrl'] = oldLocation.pathname;
            state['state']['description'] = productObj?.title || productObj?.name;
          }
        } catch (error) {
          console.log(error);
        }

        if (
          !location.pathname?.includes('deals') &&
          !(location.pathname?.includes('search') && productObj['bundleTypeId'].includes('bundle'))
        ) {
          state = {
            state: {
              oldLocation: location,
              description: `${productObj?.title || productObj?.name}`,
              retUrl: returnURL,
            },
          };
        }

        const category =
          categoryList.entities[productsMap[mainProductId || productObj?.id]?.['categories']?.[0]];
        let productRoute = generateProductRoute({
          product: productsMap[mainProductId || productObj?.id],
          category,
          locale: intl.locale.toLowerCase(),
        });

        if (productObj?.bundleTypeId == 'bundle' && productObj?.typeId != 'simple') {
          productRoute = productRoute + '/bundle';
        }

        console.log(`removing unlockedStepperId 4`);
        window.localStorage.removeItem('unlockedStepperId');
        navigate(productRoute, state);
        setShowCustomizeProductDialog((prev) => 0);
      });
    }
  };
  let cartProductList = cart.data?.items?.filter((item) => item.id == showCustomizeProductDialog);
  let cartProductData = cart.data?.items?.find(
    (item) =>
      item.catId == showCustomizeProductDialog ||
      item?.additionalInfo?.selectedBundleId == showCustomizeProductDialog ||
      item.id == showCustomizeProductDialog
  );

  let cartCustomizeList = temp.customize?.items?.filter(
    (item) => item.id == showCustomizeProductDialog
  );

  const cartIndex = cartProductList.length > 0 ? cartProductList.length - 1 : -1;
  const customizeIndex = cartCustomizeList.length > 0 ? cartCustomizeList.length - 1 : -1;
  let cartProduct = cartCustomizeList[customizeIndex] || cartProductList[cartIndex];
  let customizeItem = temp.customize?.items?.find((item) => item.id == showCustomizeProductDialog);

  if (!customizeItem) {
    customizeItem = temp.customize?.items?.find(
      (item) =>
        item?.additionalInfo?.selectedBundleId == showCustomizeProductDialog ||
        item.catId == showCustomizeProductDialog
    );
  }

  let valuesArray = Object.values(cartProduct?.added || {});
  const removedValue = Object.values(cartProduct?.removed || {});

  if (cartProduct?.items) {
    let allItems = [];
    for (let itemObj of Object.values(cartProduct?.items || {})) {
      for (let id of Object.keys(itemObj)) {
        allItems.push(id);
      }
    }

    let finalValues = [];
    for (let [id, str] of Object.entries(cartProduct?.added || {})) {
      if (allItems.includes(id)) {
        finalValues.push(str);
      }
    }
    valuesArray = finalValues;
  }

  let stringToAdd = valuesArray.join(', ');
  let removedString = removedValue.join(', ');
  let repeatCustomizationPrice = (cartProduct?.price || 0) / (cartProduct?.qty || 1);
  let prodPrice = 0;

  if (productId) {
    cartProductList = [customizations];
    cartProductData = customizations;
    cartCustomizeList = [customizations];
    cartProduct = customizations;

    let defaultVariations = [-1, -1, -1];
    Object.values(productObj?.variants || {}).forEach((variant, index) => {
      const selection = variant?.options?.find((option) => option?.isSelected == 1);
      if (selection) {
        defaultVariations[index] = selection?.id;
      }
    });
    let defaultItem = productObj?.items?.find((item) => {
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }

      let isVariantSame = true;
      defaultVariations.forEach((variant, index) => {
        if (itemInfo[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });

    if (!defaultItem?.id) {
      defaultItem = productsMap[defaultItem];
    }

    if (!defaultItem?.steps?.[0]?.options) {
      defaultItem =
        productsMap[productObj?.id]?.items?.find((item) => item?.id == defaultItem?.id) ||
        defaultItem;
    }

    prodPrice =
      defaultItem?.price >= 0
        ? defaultItem?.price
        : defaultItem?.specialPrice || defaultItem?.originalPrice || 0;

    // calculate price and strings
    let productVariations = Object.values(customizations?.variants || {});
    let selectedItemObj = productObj;

    if (productVariations?.length) {
      selectedItemObj = productObj?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        let isVariantSame = true;
        productVariations.forEach((variant, index) => {
          if (itemInfo[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      if (!selectedItemObj?.id) {
        selectedItemObj = productsMap[selectedItemObj];
      }
    }

    if (!selectedItemObj?.steps?.[0]?.options) {
      selectedItemObj = productsMap[productObj?.id]?.items?.find(
        (item) => item?.id == selectedItemObj?.id
      );
    }

    // just calculate the base price + extra price
    let itemExtraPrice = 0;
    let itemBasePrice =
      selectedItemObj?.price >= 0
        ? selectedItemObj?.price
        : selectedItemObj?.originalPrice || selectedItemObj?.specialPrice || 0;

    for (let step of selectedItemObj?.steps || []) {
      for (let option of step?.options || []) {
        if (option?.subOptions) {
          itemExtraPrice +=
            option?.subOptions[customizations?.items?.[step.id]?.[option.id]?.['qty'] - 1]?.price ||
            0;
        } else {
          if (customizations?.items?.[step.id]?.[option.id]?.['qty']) {
            itemExtraPrice +=
              (option?.price || 0) *
              Number(customizations?.items?.[step.id]?.[option.id]?.['qty'] || 0);
          }
        }
      }
    }

    repeatCustomizationPrice = parseFloat(itemBasePrice);
    repeatCustomizationPrice += parseFloat(itemExtraPrice);

    stringToAdd = dealAddedItems(customizations, selectedItemObj); // for configurable product
    removedString = dealRemovedItems(customizations, selectedItemObj); // for configurable product
  } else {
    let defaultVariations = [-1, -1, -1];
    Object.values(productObj?.variants || {}).forEach((variant, index) => {
      const selection = variant?.options?.find((option) => option?.isSelected == 1);
      if (selection) {
        defaultVariations[index] = selection?.id;
      }
    });
    let defaultItem = productObj?.items?.find((item) => {
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }

      let isVariantSame = true;
      defaultVariations.forEach((variant, index) => {
        if (itemInfo[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });

    if (!defaultItem?.id) {
      defaultItem = productsMap[defaultItem];
    }

    if (!defaultItem?.steps?.[0]?.options) {
      defaultItem =
        productsMap[productObj?.id]?.items?.find((item) => item?.id == defaultItem?.id) ||
        defaultItem;
    }

    prodPrice =
      defaultItem?.price >= 0
        ? defaultItem?.price
        : defaultItem?.specialPrice || defaultItem?.originalPrice || 0;
  }

  const renderPrice = selectedOption == 0 ? repeatCustomizationPrice : prodPrice;

  const customisedBtn = () => {
    // debugger;
    return (
      <>
        <div className={css.customizeAgain} onClick={(e) => handleRoute(e)}>
          <span>
            <FormattedMessage id={'customize_again'} defaultMessage={'Customize Again'} />
          </span>
        </div>
        <ProductAddToCart
          forceDisableHide={true}
          popup={true}
          isDesktop={isDesktop}
          isBundleItem={
            productsMap[showCustomizeProductDialog]?.bundleTypeId == 'bundle' ||
            productsMap[showCustomizeProductDialog]?.bundleTypeId == 'bundle_group' ||
            productsMap[showCustomizeProductDialog]?.typeId == 'bundle' ||
            productsMap[showCustomizeProductDialog]?.typeId == 'bundle_group'
          }
          showIcon={!isBundleItem}
          productID={showCustomizeProductDialog}
          buttonText={
            isBundleItem ? (
              <FormattedMessage id="checkout_proceed" defaultMessage="Proceed" />
            ) : (
              <FormattedMessage id="product_addtocart" defaultMessage="Add to cart" />
            )
          }
          onClick={handleCheckout}
          price={renderPrice}
          selectedProduct={productsMap[showCustomizeProductDialog]}
          categoryID={productsMap[showCustomizeProductDialog]?.categories[0]}
          imgSrc={`${
            selectedItem?.assets?.[0]?.src ||
            productsMap[showCustomizeProductDialog]?.assets?.[0]?.src
          }`}
          showCustomizeProductDialog={showCustomizeProductDialog}
        />
      </>
    );
  };

  const renderMobileTile = () => {
    let prod = productsMap[showCustomizeProductDialog];

    if (isBundleItem) {
      let stepInfo;
      if (
        productsMap[mainProductId]?.isBOGO ||
        productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
      ) {
        const paramsStepId = parseInt(locationSearch.get('step'));
        const optionId = parseInt(locationSearch.get('option'));

        let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
      } else {
        stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepperId);
      }
      prod = stepInfo?.options?.find((option) => option?.id == showCustomizeProductDialog);
    }

    if (!prod) {
      prod = productObj;
    }

    if (!prod) {
      return '';
    }
    return (
      <div className={css.mobileTitleWrap}>
        <span>{prod?.name || prod?.title}</span>

        <BackButton handleBack={() => setShowCustomizeProductDialog((prev) => 0)} type="cross" />
      </div>
    );
  };

  const RenderConfigurable = ({ val, bogo = false, idx }) => {
    if (!val) {
      return '';
    }

    return (
      <>
        {val.title && val.title !== '' && bogo && (
          <div className={css.bogotitle}>
            <span>{idx + 1}.</span>
            <span className={css.bogoName}>{val?.title}</span>
            <span className={cx(css.bogoPrice, idx === 1 ? css.strikePrice : '')}>
              {decimalChecker(val.defaultPrice)} {countryValidations.currency}
            </span>
          </div>
        )}
        <div className={cx(css.editItem, css.simpleProd)}>
          {val.subtitle && val.subtitle !== '' && (
            <div className={css.subTitle}>{val?.subtitle}</div>
          )}
          {val.description && val.description !== '' && !bogo && (
            <div className={css.descriptionValue}>{val.description}</div>
          )}

          {val.added && val.added !== '' && (
            <div className={css.added}>
              <div className={css.addedDesc}>
                <span>
                  <FormattedMessage id="added" defaultMessage="Added" />
                </span>{' '}
                -{val?.added}
              </div>
              {val?.price !== 0 ? (
                <div className={css.addedPrice}>
                  + {decimalChecker(val?.price)} {countryValidations.currency}
                </div>
              ) : (
                ''
              )}
            </div>
          )}
          {val.removed && val.removed !== '' && (
            <div className={css.bundleStepRemoved}>
              <span className={css.redText}>
                <FormattedMessage id="removed" defaultMessage="Removed" /> :
              </span>
              {` ${val.removed}`}
            </div>
          )}
        </div>
        <Divider className={css.divider} />
      </>
    );
  };

  const RenderDetailView = ({ val, idx }) => {
    // debugger;
    return (
      <>
        <div className={css.viewItem}>
          <div className={css.editItem}>
            {val.title && val.title !== '' && (
              <div
                className={cx({
                  [css.isAddOns]:
                    (val.addons && decimalChecker(val?.price) > 0) ||
                    (val.qty &&
                      decimalChecker(val?.defaultPrice) > 0 &&
                      decimalChecker(val?.price) > 0) ||
                    decimalChecker(val.extraBasePrice) > 0,
                })}
              >
                <div className={css.title}>{val?.title}</div>
                <div
                  className={cx(
                    {
                      [css.added]:
                        (val.addons && decimalChecker(val?.price) > 0) ||
                        (val.qty && decimalChecker(val?.defaultPrice) > 0 && !val?.added),
                    },
                    { [css.isExtraAdded]: decimalChecker(val.extraBasePrice) > 0 }
                  )}
                >
                  {/* {decimalChecker(val.extraBasePrice) > 0
                  ? `+${decimalChecker(val.extraBasePrice)} ${countryValidations.currency}`
                  : ''} */}
                  {(val.addons && decimalChecker(val?.price) > 0) ||
                  (val.qty &&
                    decimalChecker(val?.defaultPrice) > 0 &&
                    decimalChecker(val?.price) > 0 &&
                    !val?.added) ? (
                    <div className={css.addedPrice}>
                      + {decimalChecker(val?.price)} {countryValidations.currency}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            )}
            {val.subtitle && val.subtitle !== '' && (
              <div className={css.subTitle}>{val?.subtitle}</div>
            )}

            {val.added && val.added !== '' && (
              <>
                <div className={css.added}>
                  <div className={css.addedDesc}>
                    <span>
                      <FormattedMessage id="added" defaultMessage="Added" />
                    </span>{' '}
                    -{val?.added}
                  </div>
                </div>
              </>
            )}
            {val.removed && val.removed !== '' && (
              <div className={css.bundleStepRemoved}>
                <span className={css.redText}>
                  <FormattedMessage id="removed" defaultMessage="Removed" /> :
                </span>
                {` ${val.removed}`}
              </div>
            )}
          </div>
          {val.added && val.added !== '' && (
            <div className={css.addedPrice}>
              <FormattedMessage id="you_need_to_pay_extra" defaultMessage="You Need To Pay Extra" />
              :
              <span>
                {' '}
                +{decimalChecker(val?.price)} {countryValidations.currency}
              </span>
            </div>
          )}
        </div>
        {/* <Divider className={css.divider} /> */}
      </>
    );
  };

  const RenderSubitems = () => {
    let subItems = JSON.parse(JSON.stringify(customizeItem?.subList || []));
    if (
      (subItems[0]?.specialPrice || subItems[0]?.originalPrice || 0) ==
      (subItems[1]?.specialPrice || subItems[1]?.originalPrice || 0)
    ) {
      subItems.sort((item1, item2) => item2.price - item1.price);
    } else {
      subItems.sort(
        (item1, item2) =>
          (item2?.specialPrice || item2?.originalPrice) -
          (item1?.specialPrice || item1?.originalPrice)
      );
    }

    return (
      <>
        {subItems?.map((itm, idx) => {
          return (
            // <div className={css.bogoHeading}>{idx}. </div>
            <RenderConfigurable bogo={true} idx={idx} val={itm?.editDesc?.[0]} />
          );
        })}
      </>
    );
  };

  const renderDetail = () => {
    // if (!cartProductData?.editDesc?.length && !cartProductData?.subItem) {
    //   return '';
    // }
    // debugger;
    return (
      <div className={css.bundleStepItem}>
        <div className={css.renderTitle}>{productObj?.name}</div>
        {/* <span className={css.productPrice}>{`${decimalChecker(
          customizeItem?.specialPrice || customizeItem?.price || 0
        )} ${countryValidations.currency}`}</span> */}

        {(customizeItem?.typeId !== 'bundle' && !customizeItem?.subItem) ||
        (customizeItem?.typeId === 'bundle' && productObj?.typeId === 'simple') ? (
          customizeItem?.editDesc?.map((val) => {
            return <RenderConfigurable val={val} />;
          })
        ) : customizeItem?.editDesc && !customizeItem?.subItem ? (
          customizeItem?.editDesc.map((val, idx) => {
            if (idx === 0) return '';
            else {
              return (
                <>
                  <div className={css.dealsView}>
                    <BundleStepThumb
                      steps={productObj.steps}
                      val={val}
                      idx={idx}
                      custItem={customizeItem}
                      customizeBundle={customizeItem.bundle}
                      productObj={productObj}
                    />
                    <RenderDetailView val={val} idx={idx} />
                  </div>
                </>
              );
            }
          })
        ) : (
          <>
            <RenderSubitems />
          </>
        )}
      </div>
    );
  };

  const renderDeals = () => {
    // debugger;

    if (showLoader) {
      return <CustomizationSkelton />;
    }
    return (
      <>
        {!isDesktop && renderMobileTile()}
        <div className={css.viewDetailsDialogContent}>
          <div className={cx(css.detailsContainer, css.dealsContainer)}>
            {repeatTitle()}
            {/* case: simple */}
            {productObj?.bundleTypeId === 'simple' && (
              <div className={css.viewDetailsDescription}>{productObj.description}</div>
            )}

            {/* case: configurable */}
            {productObj?.bundleTypeId === 'configurable' && (
              <>
                <div className={css.viewDetailsVariant}>
                  {getVariantDetails(customizations, productObj)}
                </div>
                <div className={css.viewDetailsDescription}>{productObj.description}</div>
                {selectCustomize?.added && (
                  <div className={css.viewDetailsAddedItems}>
                    <div className={css.row1}>
                      <span className={css.greenText}>
                        <FormattedMessage id="added" defaultMessage="Added" /> :
                      </span>
                      {` ${stringToAdd}`}
                    </div>
                  </div>
                )}
                {removedDealItems && isDesktop && (
                  <div className={css.viewDetailsRemovedItems}>
                    <span className={css.redText}>
                      <FormattedMessage id="removed" defaultMessage="Removed" /> :
                    </span>
                    {` ${removedDealItems}`}
                  </div>
                )}
              </>
            )}
            {/* case: Bundle / Bundle_Group */}
            {renderDetail()}
          </div>
          {customisedBtn()}
        </div>
      </>
    );
  };

  const renderContent = () => {
    let prodObj = productsMap[cartProduct.id] || productObj;
    if (!prodObj) {
      return '';
    }

    let productVariations = Object.values(customizations?.variants || {});
    let selectedItemObj = prodObj;

    if (productVariations?.length) {
      selectedItemObj = prodObj?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        let isVariantSame = true;
        productVariations.forEach((variant, index) => {
          if (itemInfo[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      if (!selectedItemObj?.id) {
        selectedItemObj = productsMap[selectedItemObj];
      }

      if (!selectedItemObj?.steps?.[0]?.options) {
        selectedItemObj =
          productsMap[prodObj?.id]?.items?.find((item) => item?.id == selectedItemObj?.id) ||
          selectedItemObj;
      }
    }

    let cost = 0;

    if (productId) {
      // just calculate the base price + extra price
      let itemExtraPrice = 0;
      let itemBasePrice =
        selectedItemObj?.price >= 0
          ? selectedItemObj?.price
          : selectedItemObj?.originalPrice || selectedItemObj?.specialPrice || 0;
      for (let step of selectedItemObj?.steps || []) {
        for (let option of step?.options || []) {
          if (option?.subOptions) {
            itemExtraPrice +=
              option?.subOptions[customizations?.items?.[step.id]?.[option.id]?.['qty'] - 1]
                ?.price || 0;
          } else {
            if (customizations?.items?.[step.id]?.[option.id]?.['qty']) {
              itemExtraPrice +=
                (option?.price || 0) *
                Number(customizations?.items?.[step.id]?.[option.id]?.['qty'] || 0);
            }
          }
        }
      }

      if (isBundleItem && !productsMap[productId]?.isBOGO) {
        cost += parseFloat(itemBasePrice);
      }
      cost += parseFloat(itemExtraPrice);
    } else {
      const cartPriceItem = cartProduct.price / (cartProduct?.qty || 1);
      cost = cartPriceItem - (selectedItemObj?.originalPrice || selectedItemObj?.specialPrice || 0);
    }
    const RenderDetailofItem = (val) => {
      return (
        <>
          <div className={css.editDes}>
            {val.added && val.added !== '' && (
              <div className={css.added}>
                <div className={css.addedDesc}>
                  <span>
                    <FormattedMessage id="added" defaultMessage="Added" />
                  </span>{' '}
                  -{val?.added}
                </div>
                {/* {val?.price !== 0 ? (
                  <div className={css.addedPrice}>
                    + {decimalChecker(val?.price)} {countryValidations.currency}
                  </div>
                ) : (
                  ''
                )} */}
              </div>
            )}
            {val.removed && val.removed !== '' && (
              <div className={css.bundleStepRemoved}>
                <span className={css.redText}>
                  <FormattedMessage id="removed" defaultMessage="Removed" /> :
                </span>
                {` ${val.removed}`}
              </div>
            )}
          </div>
        </>
      );
    };

    return (
      <>
        {!isDesktop && renderMobileTile()}
        {(!!selectedSize || !!selectedType) && (
          <div className={css.sizeWrap}>
            <span className={css.lightStyle}>Size</span>
            <span className={css.boldStyle}>{selectedSize}</span>
            <span className={css.lightStyle}>Crust</span>
            <span className={css.boldStyle}>{selectedType}</span>
          </div>
        )}
        <div
          className={cx(css.customizeDialog, { [css.custSelected]: selectedOption === 0 })}
          onClick={() => setSelectedOption(0)}
        >
          <div className={css.innerCon}>
            {repeatTitle()}

            {customizeItem?.editDesc && customizeItem?.editDesc[0] ? (
              RenderDetailofItem(customizeItem?.editDesc[0])
            ) : (
              <>
                {stringToAdd !== '' && (
                  <div className={cx(css.productCustomizationRow, css.addwrap)}>
                    <span className={css.greenText}>
                      <FormattedMessage id="added" defaultMessage="Added" /> :
                    </span>
                    <span className={cx(css.defaultItemStyle, css.styleAddedItems)}>
                      {stringToAdd}
                    </span>
                  </div>
                )}
                {removedString !== '' && (
                  <div className={css.productCustomizationRow}>
                    <span className={css.redText}>
                      <FormattedMessage id="removed" defaultMessage="Removed" /> :
                    </span>
                    <span className={css.defaultItemStyle}>{removedString}</span>
                  </div>
                )}
              </>
            )}
            {/* <hr /> */}
            {cost > 0 ? (
              <div className={cx(css.customizeDialogTitle, css.extra)}>
                <FormattedMessage
                  id="you_need_to_pay_extra"
                  defaultMessage="You Need To Pay Extra"
                />{' '}
                :
                <span className={css.greenText}>
                  {decimalChecker(cost)} <span>{countryValidations.currency}</span>
                </span>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>

        {!buildCat &&
          productsMap[productId || showCustomizeProductDialog]?.bundleTypeId?.includes(
            'configurable'
          ) && (
            <div
              className={cx(css.customizeDialog, { [css.custSelected]: selectedOption === 1 })}
              onClick={() => setSelectedOption(1)}
            >
              <div className={(css.productCustomizationRow, css.defaultCustomize)}>
                <Radio
                  checked={selectedOption == 1}
                  color="primary"
                  id={showCustomizeProductDialog}
                  edge="end"
                  onClick={() => setSelectedOption(1)}
                />
                <span className={css.customizeDialogTitle}>
                  <FormattedMessage
                    id="continue_with_default_toppings"
                    defaultMessage="Continue With Default Toppings"
                  />
                </span>
                <p className={css.defaultItemStyle}>{defaultItems}</p>
              </div>
            </div>
          )}
        {customisedBtn()}
      </>
    );
  };

  let productInfo = productsMap[showCustomizeProductDialog];
  if (isBundleItem) {
    let stepInfo;
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const paramsStepId = parseInt(locationSearch.get('step'));
      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
    } else {
      stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == currentStepperId);
    }
    productInfo = stepInfo?.options?.find((option) => option?.id == showCustomizeProductDialog);
  }

  if (!productInfo) {
    productInfo = productObj;
  }

  return (
    <>
      {isDesktop ? (
        <DialogBox
          title={productInfo?.name || productInfo?.title}
          size="md"
          className={cx(css.dealSelectionDialog)}
          isOpen={showCustomizeProductDialog}
          onClose={() => setShowCustomizeProductDialog((prev) => 0)}
          hideCloseButton
          hidden
        >
          {productObj?.typeId === 'configurable' ? renderContent() : renderDeals()}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          className={cx(css.dealSelectionDialog)}
          open={showCustomizeProductDialog}
          onClose={() => setShowCustomizeProductDialog(0)}
          hideCloseButton
        >
          {productObj?.typeId === 'configurable' ? renderContent() : renderDeals()}
        </DrawerPwa>
      )}
    </>
  );
}

export default ProductCustomizationDialog;
